const one = {
  state: {
    isPC: true
  },
  mutations: {
    IS_PC: (state, isPC) => {
      state.isPC = isPC
    }
  }
}

export default one



// WEBPACK FOOTER //
// ./src/store/modules/one.js